export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ofertas"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mis operaciones"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mis anuncios"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Operaciones"])}
}